import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import BasicLayout from './components/layout/BasicLayout'
import MainPage from './pages/MainPage'
import NoMatch from './pages/NoMatch'
import FAQPage from './pages/FAQPage'
import ContactPage from './pages/ContactPage'

function App() {
	gsap.registerPlugin(ScrollTrigger)

	return (
		<Router>
			<Helmet>
				<title>타고가</title>
			</Helmet>
			<Route path={['/', '/faq', '/contact']} exact>
				<BasicLayout>
					<Switch>
						<Route exact path="/contact">
							<ContactPage />
						</Route>
						<Route exact path="/faq">
							<FAQPage />
						</Route>
						<Route exact path="/">
							<MainPage />
						</Route>
						<Route path="*">
							<NoMatch />
						</Route>
					</Switch>
				</BasicLayout>
			</Route>
		</Router>
	)
}

export default App
